import React, {useState,useEffect} from "react";
import {useSelector} from "inbooma-api";
import FormItem from "../../../components/FormItem";
import {$} from "../../../../../vendor";
import TimeInput from 'react-time-input';

const SubItemView = (props) => {
    const { dispatch, visualInspection, visualInspectionItem, visualInspectionItemsActions,visualInspectionsActions,requestPath, locations, contingents, Biscuit, moment, t, language,currentUrl,rbac, showNotification} = props;
    const [savePending, setSavePending] = useState(false);
    const _editVisualInspectionItem = useSelector(state => state['visual_inspection_items_data'].patchVisualInspectionItem);
    const _addVisualInspectionItem = useSelector(state => state['visual_inspection_items_data'].addVisualInspectionItem);
    const [item,setItem] = useState(
        typeof visualInspectionItem.id === 'undefined'?
            {
                visual_inspection_id: visualInspection.id,
                location_id: null,
                contingent_id: null,
                begin: null,
                end: null
            }: visualInspectionItem
    );
    const saveState=item;
    const onSubmit = () => {
        if(typeof item.id !== 'undefined') //edit
        {
            console.log('it is edit');
            dispatch(visualInspectionItemsActions.patchVisualInspectionItem(
                {
                    token: Biscuit.get('token'),
                    data: item,
                    id: item.id,
                    parameters: {
                        headers: {
                            'Accept-Language': language,
                            'Content-Language': language
                        }
                    }
                }
            ));
            setSavePending(true);
        }else {  //add
            console.log('it is add');
            dispatch(visualInspectionItemsActions.addVisualInspectionItem(
                {
                    token: Biscuit.get('token'),
                    data: item,
                    parameters: {
                        headers: {
                            'Accept-Language': language,
                            'Content-Language': language
                        }
                    }
                }
            ));
            setSavePending(true);
        }
    };
    const onChangeLocation = (e) => {
        let clone = {};
        Object.assign(clone,item);
        if(e.target.value !== null){
            $('.location_select select').css('border-color','rgb(227, 227, 227)');
        }
        clone.location_id = e.target.value;
        setItem(clone);
    };
    const onChangeContingent = (e) => {
        let clone = {};
        Object.assign(clone,item);
        if(e.target.value !== null){
            $('.contingent_select select').css('border-color','rgb(227, 227, 227)');
        }
        clone.contingent_id = e.target.value;
        setItem(clone);
    };

    useEffect(() => {
        if(!savePending || _editVisualInspectionItem.success === ''){
            return;
        }
        if(_editVisualInspectionItem.success === true){
            showNotification('success',visualInspection.id);
            close();
        } else {
            showNotification('warning',null,_editVisualInspectionItem.data.message);
        }
    },[_editVisualInspectionItem]);

    useEffect(() => {
        if(!savePending || _addVisualInspectionItem.success === ''){
            return;
        }
        if(_addVisualInspectionItem.success === true){
            showNotification('success',visualInspection.id);
            close();
        } else {
            showNotification('warning',null,_addVisualInspectionItem.data.message);
        }
    },[_addVisualInspectionItem]);


    const close = () => {
        let changes = false;
        for (const [key, value] of Object.entries(saveState)) {
            if (value !== item[key]) {
                changes = true;
            }
        }
        let bestaetigung = (!changes)?true:window.confirm('Es gibt ungespeicherte Daten, soll das Formular dennoch geschlossen werden?');
        if (bestaetigung) {
            dispatch(visualInspectionItemsActions.getVisualInspectionItemResetData());
            dispatch(visualInspectionsActions.getVisualInspectionsResetData());
            dispatch(visualInspectionsActions.getVisualInspectionResetData());
            let returnUrl = (typeof requestPath !== 'undefined') ? requestPath + currentUrl.search : `/visual_inspections${currentUrl.search}`;
            window.location.replace(returnUrl);
        }
    };

    const onChangeField = (e,name) =>
    {
        if(e.length === 5) {
            let clone = {};
            Object.assign(clone, item);
            clone[name] = moment(item.date).format('YY-MM-DD') + ' ' + e;
            setItem(clone);
        }
    }


    const abortButtonRef = React.createRef();
    return (<>
        <div className="off-canvas position-right is-transition-overlap is-open" id="inb-off-canvas" data-off-canvas="85mrb3-off-canvas" aria-hidden="false">
        <header className="inb-header off-canvas__header off-canvas--shadow clearfix row">
            <h1 className="inb-page-title">{(typeof item.id !== undefined && item.id !== '') ? t('edit_${a}',{a:t('visual_inspection_item')}) : t('add_${a}',{a:t('visual_inspection_item')})}</h1>
            <div className="off-canvas__actions column">
                <button type="submit" className={"button medium beautify beautify-" + Biscuit.get('user.client_id')+ " button-submit round"} title={t('save')} onClick={onSubmit}>
                    {!savePending &&
                        <>
                            <i className="fi fi-check"> </i>
                            <span>{t('save')}</span>
                        </>
                    }
                    {savePending &&
                        <span><img alt="RollingLoader" className="rollingLoader" src={"assets/img/rolling_loader.svg"} />{t('save')}</span>
                    }
                </button>
                <a
                    href='#'>
                    <button ref={abortButtonRef} type="button" id="inb-tasksform-abort-button" className="button hollow secondary right button-abort round" title={t('close_window')} onClick={() => close()}>
                        <i className="fi fi-x"> </i>
                    </button>
                </a>
            </div>
        </header>
        <p className="off-canvas__subtitle off-canvas__header-region">
            {typeof item.created !== 'undefined' &&
                t('created_at') + " " + moment(item.created).format('DD.MM.YYYY HH:mm:ss') + " " +
                t('edited_by') + " " + item.created_by_name + " | " +
                t('last_modified_at') + " " + moment(item.modified).format('DD.MM.YYYY HH:mm:ss') + " " +
                t('edited_by') + " " + item.modified_by_name
            }
        </p>
        <form className="off-content row">
            {rbac.hasPermission('setLocation') && <FormItem
                name="location_id"
                inputType="select"
                id={"visual_inspection_item_location_id_"+(typeof item.id !== 'undefined'?item.id:'new')}
                label={t('location',null,'capital')}
                type="select"
                dataKey="id"
                data={locations}
                selected={item.location_id !== null?item.location_id:''}
                mediumWidth={6}
                smallWidth={12}
                onChangeHandler={onChangeLocation}
                placeholder={t('please_select')}
                extraTopClasses="location_select"
                />}
            {rbac.hasPermission('setContingent') && <FormItem
                name="contingent_id"
                inputType="select"
                id={"visual_inspection_item_contingent_id_"+(typeof item.id !== 'undefined'?item.id:'new')}
                label={t('contingent',null,'capital')}
                type="select"
                dataKey="id"
                data={contingents}
                selected={item.contingent_id !== null?item.contingent_id:''}
                mediumWidth={6}
                smallWidth={12}
                onChangeHandler={onChangeContingent}
                placeholder={t('please_select')}
                extraTopClasses="contingent_select"
            />}
            <div className="list-item-block-offcanvas medium-6 small-6 column">
                <label>{t('valid_from',null,'capital')}</label>
                <TimeInput
                    initTime={moment(item.begin).format('HH:mm')}
                    className='input-group-field'
                    mountFocus='true'
                    onTimeChange={(e)=>{onChangeField(e,"begin")}}
                />
                {/*<input
                    className="input-group-field"
                    type="time"
                    name="valid_from_time_field"
                    value={moment(item.begin).format('HH:mm')}
                    style={{maxWidth: "40%"}}
                    onChange={(e)=>{onChangeField(e,"begin")}}
                />*/}
            </div>
            <div className="list-item-block-offcanvas medium-6 small-6 column">
                <label>{t('valid_to',null,'capital')}</label>
                <TimeInput
                    initTime={moment(item.end).format('HH:mm')}
                    className='input-group-field'
                    mountFocus='true'
                    onTimeChange={(e)=>{onChangeField(e,"end")}}
                />
                {/*<input
                    className="input-group-field"
                    type="time"
                    name="valid_to_time_field"
                    value={moment(item.end).format('HH:mm')}
                    style={{maxWidth: "40%"}}
                    onChange={(e)=>{onChangeField(e,"end")}}
                />*/}
            </div>


        </form>
        </div>
        </>);
}
export default SubItemView;